import {useCallback, useEffect, useReducer} from "react";
import {ITeamsContext} from "../TeamsContext/TeamsContext.interfaces";
import {initialState, reducer} from "./UsersListsContext.reducer";
import {UsersListsContextDispatchMessageType} from "./UsersListsContext.interfaces";
import {MailingListApi} from "../../apis/mailingListApi";
import {MailingList} from "../../Interfaces/MailingList";

export const useUsersListsContext = (teamsContext: ITeamsContext) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(function onMount() {
        if (!teamsContext.loaded) return;
        fetchAllUsersLists().then();
    }, [teamsContext.loaded]);

    const fetchAllUsersLists = useCallback(async () => {
        const lists = await MailingListApi.getAllMailingLists();
        dispatch([
            {type: UsersListsContextDispatchMessageType.SetLists, lists},
            {type: UsersListsContextDispatchMessageType.SetLoaded, value: true}
        ]);
    }, []);

    const addUpdateUsersList = useCallback((usersList: MailingList): Promise<MailingList> => {
        return new Promise<MailingList>(async resolve => {
            if (!usersList.id) {
                const addedList = await MailingListApi.addMailingList(usersList);
                if (!addedList) return;
                usersList.id = addedList.id;
            } else await MailingListApi.updateMailingList(usersList);
            dispatch([{
                type: UsersListsContextDispatchMessageType.AddUpdateUsersList,
                list: usersList
            }]);
            resolve(usersList);
        })
    }, []);

    const deleteUsersList = useCallback((id: string): Promise<void> => {
        return new Promise<void>(async resolve => {
            dispatch([{type: UsersListsContextDispatchMessageType.DeleteUsersList, id}]);
            await MailingListApi.deleteMailingList(id);
            resolve();
        })
    }, []);

    return {
        ...state,
        addUpdateUsersList,
        deleteUsersList
    }
}